module.exports = __webpack_public_path__ + "img/patronFundacion.b28d0048.png";